import { LitElement } from "lit";
import { use } from "lit-translate";

export class BasicApp extends LitElement {
  static get properties() {
    return {
      hasLoadedStrings: false
    };
  }

  shouldUpdate (changedProperties) {
    return this.hasLoadedStrings && super.shouldUpdate(changedProperties)
  }

  async connectedCallback () {
    super.connectedCallback();

    const currentLang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "en"
    await use(currentLang)
    this.hasLoadedStrings = true
  }

}
